import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/store/store";
import { infrastructureArchitectureRequestDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRequestDataSelector";
import { infrastructureArchitectureHierarchySelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureHierarchySelector";
import { infrastructureArchitectureDiagramEmptyDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramEmptyDataSelector";
import { InfrastructureArchitectureLocalStorageData } from "@/store/infrastructure-architecture/utils/types/types";
import { infrastructureArchitectureStatePreferenceKey } from "@/store/infrastructure-architecture/utils/constants/constants";
import { getInfrastructureArchitectureRecommendationEndpointSelector } from "@/store/infrastructure-architecture/selectors/getInfrastructureArchitectureRecommendationEndpointSelector";
import { infrastructureArchitectureDiagramDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureDiagramDataSelector";

export const saveInfrastructureArchitectureStateInLocalStorageThunk =
  createAsyncThunk(
    "infrastructureArchitecture/saveInfrastructureArchitectureStateInUserPref",
    async (_, { getState }) => {
      const state = getState() as RootState;

      const requestData =
        infrastructureArchitectureRequestDataSelector(state) ?? null;
      const diagramData =
        infrastructureArchitectureDiagramDataSelector(state) ?? null;
      const hierarchy =
        infrastructureArchitectureHierarchySelector(state) ?? null;
      const recommendationData =
        getInfrastructureArchitectureRecommendationEndpointSelector(state)
          ?.data ?? null;
      const diagramEmpty =
        infrastructureArchitectureDiagramEmptyDataSelector(state);

      const value: InfrastructureArchitectureLocalStorageData = {
        requestData,
        hierarchy,
        diagramData,
        recommendationData,
      };

      if (diagramEmpty) {
        return;
      }

      localStorage.setItem(
        infrastructureArchitectureStatePreferenceKey,
        JSON.stringify(value),
      );
    },
  );
